// Constants
import ColumnName from '../column-name/column-name.constants';
import Kendo from '../../../constants/kendo.constants';

export default {
  columns: [
    {
      ...ColumnName.buttons,
      cell: Kendo.cellTemplateNames.buttons,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      columnMenu: false,
      selected: true,
      width: Kendo.size.width.buttons
    },
    {
      ...ColumnName.Fluid.fluidTypeID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidTypeName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.Fluid.fluidName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidId,
      filter: Kendo.filter.numeric,
      filterable: false,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: false,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.originalFluidName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidManufacturerName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidManufacturerID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBrandName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBrandID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidClass,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidClassID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidWeightName,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.Fluid.fluidWeightID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.small
    },
    {
      ...ColumnName.Fluid.fluidKeywords,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidComments,
      filter: Kendo.filter.text,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBaselineSampleNumber,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBaselineSampleDate,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.fluidBaselineSampleID,
      filter: Kendo.filter.numeric,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.default
    },
    {
      ...ColumnName.Fluid.isActive,
      filter: Kendo.filter.boolean,
      minResizableWidth: Kendo.size.minResizableWidth,
      width: Kendo.size.width.boolean
    },
    {
      ...ColumnName.Fluid.createdOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.date
    },
    {
      ...ColumnName.Fluid.modifiedOn,
      filter: Kendo.filter.date,
      minResizableWidth: Kendo.size.minResizableWidth,
      selected: true,
      width: Kendo.size.width.date
    }
  ],
  doClientSide: false,
  filter: {
    logic: 'and',
    filters: []
  },
  paging: {
    pageSize: 10,
    skip: 0,
    take: 10
  },
  searchHeader: 'Search Fluids',
  searchPlaceholder: 'Enter keywords...',
  sort: [{ field: ColumnName.Fluid.fluidName.field, dir: Kendo.sort.asc }],
  title: 'Fluids Grid'
};
